import $ from "jquery";

class ClassMore {
	constructor() {
		this.init();
	}

    init() {
        this.dom();
        this.events();
    }

	dom() {
        this.$body = $('body');
        this.$moreLinks = this.$body.find('*[data-more-container][data-more-class]');
	}

    events() {
        this.$moreLinks.off('click.ClassMore');
        this.$moreLinks.on('click.ClassMore', this.clickMoreLinkHandler.bind(this));
    }

    clickMoreLinkHandler(event) {
        event.preventDefault();

        const $link = $(event.currentTarget);
        const $container = this.$body.find($link.data('more-container'));
        
        const hiddenClass = $link.data('more-class');
        const limit = $link.data('more-limit');

        let $elements = $container.find('.' + hiddenClass);
        const elementsCount = $elements.length;

        if (elementsCount < 1) return;

        if (limit) {
            $elements = $elements.filter(':lt(' + parseInt(limit) + ')');
        }
        
        $elements.removeClass(hiddenClass);

        // hide more link
        if (typeof $link.data('more-hide') !== 'undefined' && limit >= elementsCount) {
            $link.hide();
        }
    }
}

export default ClassMore;